import React, {Fragment, type FunctionComponent, useEffect} from "react"
import {Hero} from "@App/Components/Hero"
import {ContactUs} from "@App/Components/ContactUs"
import {TriangleDivider} from "@App/Components/TriangleDivider"
import {Stepper} from "@App/Components/Stepper/Stepper";
import {useServices} from "@App/hooks/api/useServices";
import {useTranslation} from "react-i18next";
import {useHome} from "@App/hooks/useHome";
import {Benefits} from "@App/Pages/Partner/Partials/Benefits";
import {LocationStep} from "@App/Pages/Partner/Partials/LocationStep";
import {MileageStep} from "@App/Pages/Partner/Partials/MileageStep";
import {DriverDataServiceStep} from "@App/Pages/Partner/Partials/DriverDataServiceStep";
import {useDriverData} from "@App/hooks/useDriverData";

export type HomeProps = {
    embedded?: boolean
    onSubmit: () => void
}

export const Home: FunctionComponent<HomeProps> = ({embedded = false, onSubmit}: HomeProps) => {
    const {t} = useTranslation()

    const {loading, error, services} = useServices()


    const {
        currentStep,
        setCurrentStep,
        togglePremiumService,
        toggled,
        nextStep,
        organization,
        service,
        premiumServices,
        place,
        mileage,
        simpleServiceSelect,
        serviceToggled
    } = useHome()


    const {
        createRequiredServiceArray,
        createOptionalServiceArray,
        createRequiredPremiumserviceArray,
        createOptionalPremiumserviceArray,
        driverResponse,
        setVehicleDataFromDriverResponse,
        setBevSupportFromDriverResponse
    } = useDriverData()


    const submit = () => {
        onSubmit?.()
    }

    useEffect(() => {
        setVehicleDataFromDriverResponse()
        setBevSupportFromDriverResponse()
    }, [driverResponse]);

    if (error) {
        console.log(error)
    }

    return (
        <Fragment>
            <Hero
                organization={organization}
                title={t("hero.title", {organization: organization.name})}
                subtitle={t("hero.subtitle", {organization: organization.name})}
                backgroundImage={organization.settings.hero.background_image_url ?? '/images/brand/arval-banner-darkened.jpg'}
                backgroundPosition={'bg-center'}
                height={350}
            />
            <div className="bg-white px-5 pt-5 container">
                <Stepper currentStep={currentStep} onChange={setCurrentStep}>
                    <Stepper.Step
                        title={t("homeSteps.mileage")}
                        subtitle={null}
                        completedTitle={t("homeSteps.mileage") + ': '}
                        completedGoBackLinkTitle={mileage ? mileage.toString() : ''}>
                        <MileageStep loading={loading} error={error} nextStep={nextStep}/>
                    </Stepper.Step>
                        <Stepper.Step
                            title={t('chooseSubServices')}
                            subtitle={null}
                            completedTitle={'Services: '}
                            completedGoBackLinkTitle={service ? (service.pivot.display_name ? service.pivot.display_name : service.name) : '' + `${premiumServices.length === 0 ? 'Keine Auswahl' : ''} ${premiumServices.map((selected) => (
                                `${selected.name}`
                            ))}`}>
                            <DriverDataServiceStep requiredServices={createRequiredServiceArray(driverResponse.serviceCatalog.required?.services)}
                                                   requiredPremiumServices={createRequiredPremiumserviceArray(driverResponse.serviceCatalog.required?.premiumServices)}
                                                   optionalServices={createOptionalServiceArray(driverResponse.serviceCatalog.optional?.services)}
                                                   optionalPremiumServices={createOptionalPremiumserviceArray(driverResponse.serviceCatalog.optional?.premiumServices)}
                                                   prohibitedServices={createOptionalServiceArray(driverResponse.serviceCatalog.prohibited?.services)}
                                                   prohibitedPremiumServices={createOptionalPremiumserviceArray(driverResponse.serviceCatalog.prohibited?.premiumServices)}
                                                   toggled={toggled}
                                                   serviceToggled={serviceToggled}
                                                   premiumServices={premiumServices}
                                                   selectService={simpleServiceSelect}
                                                   services={services}
                                                   service={service}
                                                   togglePremiumService={togglePremiumService} nextStep={nextStep}/>
                        </Stepper.Step>
                        <Stepper.Step title={t("Waehlen Sie Ihren Wunschort.")}
                                      completedTitle={''}
                                      completedGoBackLinkTitle={place ? place.name : ''}>
                            <LocationStep submit={submit} service={service} place={place}/>
                        </Stepper.Step>
                </Stepper>
            </div>
            {!embedded && (
                <div className="bg-neutral-100">
                    <TriangleDivider direction="left" background={"bg-white"}/>
                    <div className="px-5 py-5 container md:pb-20">
                        <div className="md:grid md:grid-cols-[50%_50%]">
                            <Benefits organization={organization}/>
                            <div className="pt-5 md:pt-0 md:ml-12">
                                <ContactUs/>
                                <div className={'mt-3'}>
                                    Es ist etwas dazwischen gekommen? <a
                                    href={"mailto:werkstattmeister@repareo.de?subject=Ayvens%20-%20Stornierung%20meines%20Werkstatttermins&body=Werkstattname%3A%20BITTE%20AUSF%C3%9CLLEN%0D%0ATag%20des%20Termins%3A%20BITTE%20AUSF%C3%9CLLEN%0D%0ATermin%20gebucht%20auf%20diesen%20Namen%3A%20BITTE%20AUSF%C3%9CLLEN"}
                                    title={"Termin absagen"}>Termin absagen</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    );
}
